var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.component},[_c('review-cards',{attrs:{"title":"Your Reviews","reviews":_vm.reviews}}),(_vm.reviews !== null && _vm.reviews.length === 0)?_c('h3',[_vm._v(" No Reviews ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }